import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MbscModule } from '@mobiscroll/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AutosizeModule } from 'ngx-autosize';
import { ComponentsPipesModule } from 'src/app/common/pipes/components/components-pipes.module';
import { GeneralPipesModule } from 'src/app/common/pipes/general-pipes.module';
import { CurrencyComponent } from 'src/app/shared/components/inputs/currency/currency.component';
import { BrMaskerModule } from 'src/app/shared/directives/br-mask/br-masker.module';

import { DirectivesModule } from '../../directives/directives.module';
import { Card2Component } from '../common/card/card-2.component';
import { ErrorDisplayComponent } from './_templates/error-display/error-display.component';
import { InputTemplatesModule } from './_templates/input-templates.module';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { AutocompleteModule } from './autocomplete/autocomplete.module';
import { ButtonBorderlessComponent } from './button-borderless/button-borderless.component';
import { ButtonFilledComponent } from './button-filled/button-filled.component';
import { ButtonSelectionComponent } from './button-selection/button-selection.component';
import { ButtonSmallComponent } from './button-small/button-small.component';
import { ButtonComponent } from './button/button.component';
import { CheckboxSelectComponent } from './checkbox-select/checkbox-select.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ChipSelectComponent } from './chip-select/chip-select.component';
import { DateTimeComponent } from './date-time/date-time.component';
import { DecimalComponent } from './decimal/decimal.component';
import { ImageComponent } from './image/image.component';
import { MultiAutocompleteComponent } from './multi-autocomplete/multi-autocomplete.component';
import { MultiAutocompleteModule } from './multi-autocomplete/multi-autocomplete.module';
import { NumberUpDown2Component } from './number-up-down/number-up-down-2.component';
import { NumberUpDownComponent } from './number-up-down/number-up-down.component';
import { QuestionComponent } from './question/question.component';
import { SelectModalComponent } from './select-modal/select.modal.component';
import { SelectionComponent } from './selection/selection.component';
import { DynamicTextInputComponent } from './text-input-dynamic/text-input-dynamic.component';
import { TextComponent } from './text/text.component';
import { TextComponentModule } from './text/text.component.module';
import { TextareaComponent } from './textarea/textarea.component';
import { ToggleComponent } from './toggle/toggle.component';

@NgModule({
  imports: [
    DirectivesModule,
    CommonModule,
    IonicModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'always' }),
    TranslateModule.forChild(),
    GeneralPipesModule,
    ComponentsPipesModule,
    AutocompleteModule,
    MultiAutocompleteModule,
    InputTemplatesModule,
    FormsModule,
    MbscModule,
    BrMaskerModule,
    AutosizeModule,
    TextComponentModule,
    NumberUpDown2Component,
    CheckboxComponent,
    SelectModalComponent,
    Card2Component,
    ButtonComponent,
    ButtonSmallComponent,
    ButtonSelectionComponent,
    ButtonFilledComponent,
    ButtonBorderlessComponent,
    ChipSelectComponent,
  ],
  declarations: [
    SelectionComponent,
    CheckboxSelectComponent,
    CurrencyComponent,
    DecimalComponent,
    TextareaComponent,
    DateTimeComponent,
    NumberUpDownComponent,
    QuestionComponent,
    ToggleComponent,
    ImageComponent,
    DynamicTextInputComponent,
  ],
  exports: [
    SelectionComponent,
    ErrorDisplayComponent,
    CheckboxSelectComponent,
    TextComponent,
    CurrencyComponent,
    DecimalComponent,
    AutocompleteComponent,
    TextareaComponent,
    MultiAutocompleteComponent,
    DateTimeComponent,
    NumberUpDownComponent,
    ButtonComponent,
    ButtonSmallComponent,
    ButtonSelectionComponent,
    QuestionComponent,
    CheckboxComponent,
    ToggleComponent,
    ImageComponent,
    NumberUpDown2Component,
    DynamicTextInputComponent,
    ButtonFilledComponent,
    ButtonBorderlessComponent,
    ChipSelectComponent,
  ],
})
export class AlbertaInputsModule {}
